import { twMerge } from 'tailwind-merge';
import { TDocumentThumbnail } from './type';

const DocumentThumbnail = (props: TDocumentThumbnail) => {
  return props.type === 'PDF' ? (
    <div
      {...props}
      className={twMerge(
        'flex h-[19px] w-[56px] items-center justify-center bg-[#DD2025] text-[#FFFFFF]',
        props.className
      )}
    >
      <span className="select-none text-xs">PDF</span>
    </div>
  ) : (
    <div
      {...props}
      className={twMerge(
        'flex h-[19px] w-[56px] items-center justify-center bg-[#3269FF] text-[#FFFFFF]',
        props.className
      )}
    >
      <span className="select-none text-xs">Word</span>
    </div>
  );
};

export default DocumentThumbnail;
